var addAppCtrlModule = angular
  .module('AddAppCtrl', [
    'AppCtrl.campaign.service',
    'AppCtrl.campaign.constant',
    'ngRoute'
  ]);

  addAppCtrlModule.directive('campaignStatusBoolean', function() {
    return {
      require: 'ngModel',
      link: function(s, e, a, ngModel) {
        ngModel.$formatters.push(function(value) {
          if (value === 'IN_PROGRESS') {
            return true;
          } else {
            return false;
          }
        });
        ngModel.$parsers.push(function(value) {
          if (value === true) {
            return 'IN_PROGRESS';
          } else if (value === false) {
            return 'PLANNING';
          }
        });
      }
    };
  });

/*************************************************************/
/******************** Controllers ****************************/
/*************************************************************/

addAppCtrlModule.controller('AddCampaignCtrl', [
  '$scope',
  'campaignService',
  '$location',
  '$window',
  '$routeParams',
  'constantService',
  'TypeLinkMatch',
  function(
    $scope,
    campaignService,
    $location,
    $window,
    $routeParams,
    constantService,
    TypeLinkMatch
  ) {
    $scope.addCampaignObject = {};

    var removeErrorMessages = function() {
      $scope.errors = {
        campaignAlreadyInUse: false,
        campaignNameRequired: false
      };
    };
    // empties the form.
    var reinitialize = function() {
      $scope.addCampaignObject.name = '';
      $scope.addCampaignObject.type = 'EMAIL';
      $scope.addCampaignObject.notes = '';
      $scope.addCampaignObject.eid = '';
      removeErrorMessages();
    };
    // initialize everything when the page loads.
    reinitialize();

    var saveCallback = function(results) {
      var type = TypeLinkMatch[$scope.addCampaignObject.type || EMAIL];
      reinitialize();
      $window.location =
        window.jvUrls.source +
        '/campaign2/campaignDetails.html#/campaign/' +
        type +
        '/summary/' +
        results.bean;
    };

    // For the details page as we are using the code. The way to differentiate the page is checking if the campaign Id is present.
    // If it is present, make the call to get the campaign details and fill in the values of the fields in the edit box. This portion is only for the campaign details page.
    if (typeof $routeParams['ceid'] !== 'undefined') {
      // event fired when we get the campaigns
      $scope.$on('campaignDetailsResults', function(event, results) {
        $scope.addCampaignObject.name = results.bean.name;
        $scope.addCampaignObject.status = results.bean.status;
        $scope.addCampaignObject.type = results.bean.type;
        $scope.addCampaignObject.notes = results.bean.notes;
        $scope.addCampaignObject.eid = results.bean.eid;
        // Type should not be shown for edit pages.
        $scope.hideCampaignType = true;
        $scope.showCampaignStatus = true;
      });
      campaignService.getDetails();
      saveCallback = function() {
        campaignService.getDetails();
        var _url = $location.url();
        //var _url = '/campaign/email/details/X45'
        for (var i = 0; i < 2; i++) {
          var _index = _url.lastIndexOf('/');
          _url = _url.substring(_index, 0);
        }
        _url += '/details/';
        // change the url to the edit mode.
        $location.path(_url + $routeParams['ceid']);
      };
    }

    // check for errors on the page and notify the caller. Returning 'true' means there is some error on the page and it has already been notified to the user.
    function checkAndDisplayErrors() {
      if ($scope.addCampaignObject.name === null || $scope.addCampaignObject.name === undefined || $scope.addCampaignObject.name.trim() === '') {
        $scope.errors.campaignNameRequired = true;
        return true;
      }
    }

    var _callback = function(results) {
      if (!!results && results.error) {
        $scope.errors.campaignAlreadyInUse = true;
      } else {
        saveCallback(results);
      }
    };

    //cancel the changes.
    $scope.cancel = function() {
      //TODO: check if there is a change.
      if (typeof $routeParams['ceid'] !== 'undefined') {
        $window.history.back();
      } else {
        // or go back to the candidate list page.
        document.location =
          window.jvUrls.source + '/campaign2/campaignList.html';
      }
    };

    // saves the new campaign
    $scope.save = function() {
      removeErrorMessages();
      if (checkAndDisplayErrors()) {
        return;
      }
      campaignService.addCampaigns($scope.addCampaignObject, _callback);
    };
  }
]);
